export const ShareList = ['카카오톡 공유', 'URL 공유'];

export const etc = [];
